import React from "react";
import OrdenPagoWizard from "./OrdenPagoWizard";

const PagoProveedores = () => <OrdenPagoWizard initialStep={0} />;

export default PagoProveedores;
